/*** IMPORTS FROM imports-loader ***/
var define = false;

import React from 'react'

// 导入css
import './index.scss'

// 项目展示组件
class Item extends React.Component {
  // constructor(props) {
  //   super(props)
  // }
  render() {
    return (
      <div>123</div>
    )
  }
}

export default Item




// WEBPACK FOOTER //
// ./src/components/Item/index.js